import type { ICompany } from '../../../massReceive/MassReceiveInterfaces';
import type { IRuleOutcome, EnumObject } from './PolicyConfiguratorInterfaces';
import {
  PHOTOGRAPHYDYNAMICWORKFLOWS,
  PRICINGWORKFLOWS, MARKINGWORKFLOWS, ROUTINGWORKFLOWS, POLICYCONFIGURATORSECTIONS, MARKINGDYNAMICBEHAVIORWORKFLOWS,
} from './PolicyConfiguratorInterfaces';
import type { IJobInfo, IJobDetail } from '../../../admin/job/JobInterfaces';
import type { IWorkViewDetail } from '../../../admin/workView/WorkViewInterfaces';

export const customOutcome = (fieldName: string, operationName: string, valueName: string): IRuleOutcome => ({
  field: fieldName,
  operation: operationName,
  value: valueName,
});

export const emptyCompany = (): ICompany => ({
  companyId: '00000000-0000-0000-0000-000000000000',
  companyName: '',
});

export const emptyJob = (): IJobInfo => ({
  id: '',
  jobFields: [],
  jobCode: '',
  jobType: { label: '', value: '' },
  stationType: '',
  fieldName: '',
});

export const emptyWorkViewDetail = (): IWorkViewDetail => ({
  workViewId: '',
  name: '',
  description: '',
  users: [],
  layoutStyle: { label: '', value: '' },
  primaryGroups: [],
});

export const emptyJobDetail = (): IJobDetail => ({
  jobId: '',
  jobFields: [],
  jobCode: '',
  jobType: { label: '', value: '' },
  stationType: { label: '', value: '' },
});

export const emptyWorkflowOutcome = (workflowName: string): IRuleOutcome => ({
  field: workflowName,
  operation: '==',
  value: '',
});

export const emptyRuleOutcome = (): IRuleOutcome => ({
  field: '',
  operation: '',
  value: '',
});

export const initialOutcomesForWorkflow = (newTabValue: string): IRuleOutcome[] => {
  switch (newTabValue) {
    case MARKINGWORKFLOWS.ADDITIONALFIELD: {
      return [{ field: 'Name', operation: '==', value: '' }, { field: 'Type', operation: '==', value: '' }];
    }
    default: {
      return [{ field: newTabValue, operation: '==', value: '' }];
    }
  }
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-return
export const getEnumValues = (e: EnumObject | undefined): string[] => (e === undefined ? new Array<string>() : Object.values(e));

export const getWorkflowFromWorkflowName = (workflowName: string): EnumObject => {
  if (Object.values<string>(PRICINGWORKFLOWS).includes(workflowName)) {
    return PRICINGWORKFLOWS;
  } if (Object.values<string>(MARKINGWORKFLOWS).includes(workflowName)) {
    return MARKINGWORKFLOWS;
  } if (Object.values<string>(ROUTINGWORKFLOWS).includes(workflowName)) {
    return ROUTINGWORKFLOWS;
  } if (Object.values<string>(MARKINGDYNAMICBEHAVIORWORKFLOWS).includes(workflowName)) {
    return MARKINGDYNAMICBEHAVIORWORKFLOWS;
  } if (Object.values<string>(PHOTOGRAPHYDYNAMICWORKFLOWS).includes(workflowName)) {
    return PHOTOGRAPHYDYNAMICWORKFLOWS;
  }
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return {} as EnumObject;
};

export const getPricingConfiguratorSectionNameFromWorkflow = (workflow: EnumObject): string => {
  switch (workflow) {
    case PRICINGWORKFLOWS:
      return POLICYCONFIGURATORSECTIONS.PRICING;
    case MARKINGWORKFLOWS:
      return POLICYCONFIGURATORSECTIONS.MARKING;
    case ROUTINGWORKFLOWS:
      return POLICYCONFIGURATORSECTIONS.ROUTING;
    case MARKINGDYNAMICBEHAVIORWORKFLOWS:
      return POLICYCONFIGURATORSECTIONS.MARKINGDYNAMICBEHAVIOR;
    case PHOTOGRAPHYDYNAMICWORKFLOWS:
      return POLICYCONFIGURATORSECTIONS.PHOTOGRAPHYDYNAMIC;
    default:
      return '';
  }
};

export const getWorkflowFromPolicyConfiguratorSection = (sectionName: POLICYCONFIGURATORSECTIONS): EnumObject => {
  switch (sectionName) {
    case POLICYCONFIGURATORSECTIONS.PRICING:
      return PRICINGWORKFLOWS;
    case POLICYCONFIGURATORSECTIONS.MARKING:
      return MARKINGWORKFLOWS;
    case POLICYCONFIGURATORSECTIONS.ROUTING:
      return ROUTINGWORKFLOWS;
    case POLICYCONFIGURATORSECTIONS.MARKINGDYNAMICBEHAVIOR:
      return MARKINGDYNAMICBEHAVIORWORKFLOWS;
    case POLICYCONFIGURATORSECTIONS.PHOTOGRAPHYDYNAMIC:
      return PHOTOGRAPHYDYNAMICWORKFLOWS;
    default:
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      return {} as EnumObject;
  }
};
